import { dataEyeSlash } from 'dls-icons-data'
import { createIcon } from '../common'

const IconEyeSlash = /*#__PURE__*/createIcon(dataEyeSlash)
export default IconEyeSlash
